export const mtlab = {
  logo_image_url: 'mtlab.png',
  header_background_color: '#74c7a0',
  logo_height: 60,

  button_color: '#74c7a0',
  button_half_border_color: '#74c7a0',

  text_font: `'Roboto', sans-serif`,
  title_font: `'Roboto', sans-serif`,
}

export const matchinnovation = {
  logo_image_url: 'matchinnovationheader.png',

  body_background_color: '#74c7a0',

  header_full_height: true,

  logo_background_color: '#74c7a0',

  token_hidden: true,

  button_color: '#E45205',
  button_radius: 25,

  button_half_border_color: '#E45205',

  text_font: `'Nunito', sans-serif`,
  title_font: `'Nunito', bold`,
}
